<template>
	<div id="cashJournal" >
		<div class="public-content " >
			<!-- 公共form表单样式 -->
			<div class="form-item-public">
				<el-form label-width="85px" inline label-position="left">
					<el-form-item label="现金日记账">
						<accounting-period @defaultTime='defaultTime'></accounting-period>
					</el-form-item>
					<el-form-item label="科目名称">
						<el-select size="mini" placeholder="请选择"	v-model="form.subjectId" 	@change='handleSelectChange' filterable>
							<el-option
						    	v-for="item in subjectData"
						    	:key="item.id"
						    	:label="item.name"
						    	:value="item.id">
						    </el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button size="mini" class='minButton' @click='getTableData'>搜索</el-button>
					</el-form-item>

					<div class="fr">
						<el-form-item>
							<el-button size='mini' v-for='item in buttons'  :key='item.id' @click="handleButtonOperation(item.function)" class='minButton'>
								{{item.name}}
							</el-button>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<public-table  :table="tableData">
				<template slot='number' slot-scope='props'>
					<el-button type='text' v-text='props.scope.row.number' @click='handClickEdit(props.scope.row)'></el-button>
				</template>
			</public-table>
		</div>
		<!-- 修改凭证  -->
		<edit-voucher :visible.sync="XG_voucherShow" :row="rows"
			@on-close-dialog="cancel" @on-success-submit="successEdit"
			v-if="XG_voucherShow">
		</edit-voucher>

		<!-- 打印导出弹框 -->
		<el-dialog :title="formData.title=='打印'?'打印设置':'导出设置'" :visible.sync="dialogShow" width="480px" :close-on-click-modal="false" class='printDialog_s'>
			<div class='print_container'>
				<div>
					<span class='printTitle' >{{formData.title=='打印'?'打印范围：':'导出范围：'}}</span>
					 <el-radio v-model="formData.scope" label="2">当前科目</el-radio>
                     <el-radio v-model="formData.scope" label="1">所有全部</el-radio>
				</div>
				<div v-show="formData.title=='打印'" style='margin-top: 20px;' >
					<span class='printTitle'>打印方向：</span>
					 <el-radio v-model="formData.direction" label="1">横向</el-radio>
                     <el-radio v-model="formData.direction" label="2">纵向</el-radio>
				</div>
        <div style='margin-top: 20px;' v-show="formData.title=='打印'">
					<span class='printTitle'>账簿封面：</span>
					<div class="inline_box">
            <el-radio v-model="formData.cover" label="1">打印</el-radio>
            <img src="../../../static/img/default_img.png" alt="" class="default_img" @click="showCover = true">
          </div>
          <el-radio v-model="formData.cover" label="2">不打印</el-radio>
				</div>
				<div style='margin-top: 20px;text-align: right;'>
					<el-button size="small" class='minButton' @click="handleClick()">{{formData.title}}</el-button>
				</div>
			</div>
		</el-dialog>

    <!-- 查看封面 -->
    <el-dialog :visible.sync="showCover" width="900px" :close-on-click-modal="true" @close="showCover = false" custom-class="coverDialog">
      <img src="../../../static/img/cover2.jpg" alt="">
		</el-dialog>
	</div>

</template>

<script>
	import {currencys} from '@/assets/utils/currencyFormat'
	import publicTable from '@/components/publicTable'
	import editVoucher from '@/components/table/editVoucher'

	import accountingPeriod from '@/components/dialog/accountingPeriod'

export default {
	data(){
		return {
			dialogShow:false,
			isFirstActive: false,
			form: {//条件筛选
				yearPeriodsStart:'',  // 当前选择开始日期
				yearPeriodsEnd: '',  // 当前选择结束日期
				subjectId: '',
			},
			formData:{
				title:'',
				scope:'2',
				direction:'2',
				subjectId: '',
				type:'',
        cover:'2',
			},
      showCover:false,
			rows: '',         // 当前点击的行
			subjectData: [],           // 科目列表
			buttons:[],					//按钮
			XG_voucherShow: false,       // 修改弹框
			tableData: {
				border: true,				// 是否带有纵向边框
				stripe: true,				// 是否带有斑马纹
				loading: false,				// 是否显示加载动画
				hasSelect: false,			// 是否显示多选
				hasOperation: false,		// 是否有操作功能
				hasContextmenu: false,		// 是否有右键功能
				hasShowSummary: false,		// 是否显示合计行
				hasShowPagination: false,	// 是否显示分页
				config: [{
					label: '日期',
					value: 'date',
					show: 'normal'
				},{
					label: '凭证字号',
					value: 'number',
					show: 'template'
				},{
					label: '摘要',
					value: 'summary',
					show: 'normal'
				},{
					label: '借方',
					value: 'debitMoney',
					show: 'normal',
					formatter: this.formatter
				},{
					label: '贷方',
					value: 'creditorMoney',
					show: 'normal',
					formatter: this.formatter
				},{
					label: '方向',
					value: 'creditDirection',
					show: 'normal'
				},{
					label: '余额',
					value: 'remainingSum',
					show: 'normal',
					formatter: this.formatter
				}],
				data: [],
				page: {
					pageNo: 1,
					pageSize: 20,
					count: 10
				},
				center: {
					textAlign: 'center',
					padding: '6px 0'
				}
			},

			nowSubjectItem: '',   // 目前选择的科目
			onceBoolean: true,    // 只执行一次
			firstGet: true,   // 请求一次
		}
	},
	components:{
		publicTable,
		accountingPeriod,
		editVoucher
	},
	created(){
		this.init();
		let params=['ac:cashjournal:print','ac:cashjournal:export'];
		this.setButtons(params,'buttons');
	},

	computed : {
		getClickCache() {
			return this.$store.state.loadstatus.isClickCache;
		},
	},
	activated() {
		if(this.getClickCache && this.isFirstActive) {
			this.getTableData();
		}
		this.isFirstActive = true;
	},
	methods:{
		init(){
			//快速访问
			//this.getTableData();
		},
		// 关闭弹框
		cancel(val){
			this.XG_voucherShow = val;
		},
		successEdit(val){//修改成功后的回调
			if(val){
				this.getTableData();
			}
		},
		// 点击修改凭证
		handClickEdit(row) {
			this.rows = row;
			this.XG_voucherShow = true;
		},

			// 给按钮设置值
			setButtons(arr,key){
				let params={
					permissions:arr.join(',')
				}
				try {
					this.$http.post('sys/menu/findPermissionMenu' , params).then(res=>{
						if(res && res.data.code == 1) {
							if(res.data.data.length){
								this[key] = res.data.data;
							}
						}
					})
				}catch(e){
				}
			},

			handleButtonOperation(name){
				this.dialogShow =true;
					switch(name){
						case 'export':
						this.formData.title ='导出';
						this.formData.scope ='2';
						this.formData.type='2';
						this.formData.subjectId=this.form.subjectId;
						break;

						case 'print':
						this.formData.title ='打印';
						this.formData.scope ='2';
						this.formData.direction='1';
						this.formData.type='1';
						this.formData.subjectId=this.form.subjectId;
						break;
					}
			},

			handleClick(){

				let params = {
					cid: sessionStorage.cid,
					type: this.formData.type,
					subjectId:this.formData.subjectId,
					token: sessionStorage.token,
					scope: this.formData.scope,
					direction: this.formData.direction,
					yearPeriodsStart: this.$util.formatDate.format(this.form.yearPeriodsStart , 'yyyyMM'),
					yearPeriodsEnd: this.$util.formatDate.format(this.form.yearPeriodsEnd , 'yyyyMM'),
          isCover:this.formData.cover == '1' ? true : false,
				}
				if('1'==params.scope){
					params.subjectId='';
				}



			const router = this.$router.resolve({
				path: 'auxiliary/write/cashJournal',
				query: params
			})
			this.dialogShow = false;
			if('1'==params.type){
				window.open(this.$rootUrl + router.href, '_blank');
			}else{
				location.href = this.$rootUrl + router.href
			}


			},


		// 表格格式化
		formatter(row, column, cellValue, index) {
			switch (column.property) {
				case 'debitMoney':
					if(!row[column.property]) {
						return "";
					}else {
						return currencys(row[column.property]);
					}
					break;
				case 'creditorMoney':
					if(!row[column.property]) {
						return "";
					}else {
						return currencys(row[column.property]);
					}
					break;
				case 'remainingSum':
					if(!row[column.property]) {
						return "";
					}else {
						return currencys(row[column.property]);

					}
					break;
			}
		},
		// 科目下拉框改变时间
		handleSelectChange(value) {
			let data = this.subjectData.find(res=>{return res.id == value});
			this.nowSubjectItem = data;
		},
		// 接收会计期间数据
		defaultTime(data) {
			this.form = Object.assign(this.form,{
				yearPeriodsStart: data.yearPeriodsStart,
				yearPeriodsEnd:  data.yearPeriodsEnd,
			})
			if(this.firstGet) {
				this.getTableData();
				this.firstGet = false;
			}
		},
		// 获取现金日记账表格
		getTableData() {
			let params={
				yearPeriodsStart: this.$util.formatDate.format(this.form.yearPeriodsStart , 'yyyyMM'),
				yearPeriodsEnd: this.$util.formatDate.format(this.form.yearPeriodsEnd , 'yyyyMM'),
				subjectId: this.form.subjectId
			}
			try{
				this.tableData.loading = true;
				this.$http.post('cashBank/list/cashJournal',params).then(res=>{
					if(res&&res.data.code==1) {
						this.tableData.loading = false;
						this.subjectData = res.data.data.subjectList;
						this.subjectData.forEach(i=>{
							i.name = i.code + '-' + i.name;
						})
						if(res.data.data.subjectList.length && this.onceBoolean) {
							this.form.subjectId = res.data.data.subjectList[0].id;
							this.nowSubjectItem = res.data.data.subjectList[0];
							this.onceBoolean = false;
						}
						this.tableData.data = res.data.data.listData.map(item => {
							if (item.id) {
								let showCertificateWord = item.certificateWord + '-' + item.number;
								this.$set(item, 'number', showCertificateWord);
							}

							if (item.remainingSum > 0) {
								this.$set(item, 'creditDirection', '借')
							} else if(item.remainingSum == 0){
								this.$set(item, 'creditDirection', '借' , this.nowSubjectItem.creditDirection)
							}else {
								Object.assign(item, {
									creditDirection: '贷',
									remainingSum: -item.remainingSum
								})
							}

							if (item.date) {
								this.$set(item, 'date', this.$util.formatDate.format(item.date, 'yyyy-MM-dd'))
							}

							// for (const i in item) {
							// 	if (typeof item[i] === 'number' && (item.remainingSum || item.debitMoney || item.creditorMoney)) {
							// 		item[i] = item[i] === 0 ? '' : Number(item[i]).toFixed(2);
							// 	}
							// }
							return item;
						})
					}else {
						this.tableData.loading = false;
					}
				})
			}catch(e) {
				this.tableData.loading = false;

			}

		}
	},
}
</script>

<style lang="less" scoped>
.inline_box{
  display: inline-block;
  position: relative;
}

.default_img{
  width: 14px;
  position: absolute;
  left: 58px;
  top: 3px;
  cursor: pointer;
}

.coverDialog{
  img{
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/accountBook/cashJournal.vue